import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ColorPaletteComponent } from '@demo/angular/demo-theme/color-palette/color-palette.component';

@Component({
  selector: 'app-demo-theme',
  templateUrl: './demo-theme.component.html',
  styleUrl: './demo-theme.component.scss',
  imports: [MatTabsModule, ColorPaletteComponent, FlexLayoutModule],
})
export class DemoThemeComponent {}
